import { inject, Service } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RuntimeConfigService } from '../services/config/runtime-config.service';

@Service()
export class HotelGuard implements CanActivate {
  private readonly config = inject(RuntimeConfigService);
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (this.config.get('product') === 'hotelRecords') {
      return true;
    }

    this.router.navigate(['/home']);
    return false;
  }
}
